export default __webpack_public_path__ + "static/media/background.de34c1db.svg";